import React, { Component } from "react";
import ReactDOM from "react-dom/client";
import ReactSelect, { components } from "react-select";
import { flushSync } from "react-dom";
import { get } from "../Libraries/Ajax/HttpService";
import { useDistrict } from "../utils/DistrictContext";
const Option = (props) => (
  <components.Option {...props}>
    <label>{props.label}</label>
  </components.Option>
);

class Example extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // optionSelected: [{ label: "PHMSCM Holdings", value: "PHMSCM Holdings" }],
      optionSelected: [],
      items: [],
      productsnew: [],
    };
  }

  // async componentDidMount() {
  //   const response = await get(`apis/account/overide_name/select/list`);
  //   const accountList = response?.data?.data?.account_override_list || [];
  //   const items = accountList.map(({ overided_name }) => ({
  //     label: overided_name,
  //     value: overided_name
  //   }));
  //   this.setState({ items });

  //   const user = JSON.parse(localStorage.getItem("MCData"));
  //   if (user?.userid) {
  //     this.handleChange(this.state.optionSelected);
  //   }
  // }
  async componentDidMount() {
    await this.loadAccounts();
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.selectedDistrict !== this.props.selectedDistrict) {
      await this.loadAccounts();
    }
  }

  loadAccounts = async () => {
    const response = await get(`apis/account/overide_name/select/list`);
    const accountList = response?.data?.data?.account_override_list || [];
    const items = accountList.map(({ overided_name }) => ({
      label: overided_name,
      value: overided_name,
    }));

    const { selectedDistrict } = this.props;
    const user = JSON.parse(localStorage.getItem("MCData"));
    console.log("districtkkkkkkkk", selectedDistrict);

    let optionSelected = [];
    if (selectedDistrict !== "FB151" && user?.userid) {
      optionSelected = [{ label: "PHMSCM Holdings", value: "PHMSCM Holdings" }];
    } else {
      optionSelected = [{ label: "429700", value: "429700" }];
    }

    this.setState({ items, optionSelected, productsnew: [] });

    if (optionSelected.length > 0) {
      this.handleChange(optionSelected);
    }
  };

  handleChange = async (selected) => {
    // Force state update before further logic
    flushSync(() => {
      this.setState({ optionSelected: [...selected] });
    });

    const product = selected.map((s) => encodeURIComponent(s.value));
    const res = await get(
      `apis/meter/account_override/select?selected=${JSON.stringify(product)}`,
    );

    const selectedMeters = res?.data?.data?.meters?.selected_meters || [];
    const products = selectedMeters.flatMap((group) =>
      group.meters.map((m) => m.meter_unique_name),
    );

    this.setState({ productsnew: products });

    if (selectedMeters.length === 0) {
      this.props?.parentCallback(res);
    } else {
      this.props?.parentCallback(res, products);
    }
  };

  render() {
    const { items, optionSelected } = this.state;

    if (!items.length) {
      return <div></div>; // or <Skeleton />
    }
    return (
      <span
        className="d-inline-block"
        data-toggle="popover"
        data-trigger="focus"
        data-content="Please select account(s)"
      >
        <ReactSelect
          classNamePrefix="rs"
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
          options={this.state.items}
          isMulti
          components={{ Option }}
          onChange={this.handleChange}
          value={this.state.optionSelected}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          maxMenuHeight={300}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
        />
      </span>
    );
  }
}

// Safe mounting with React 18/19
// const rootElement = document.getElementById("root");
// if (!rootElement._reactRootContainer) {
//   const root = ReactDOM.createRoot(rootElement);
//   root.render(<Example />);
// }

function ExampleWithDistrict(props) {
  const districtContext = useDistrict();
  const selectedDistrict =
    typeof districtContext === "string"
      ? districtContext
      : districtContext?.selectedDistrict || "";
  return <Example {...props} selectedDistrict={selectedDistrict} />;
}

export default ExampleWithDistrict;
